import { render, staticRenderFns } from "./ModalShowLink.vue?vue&type=template&id=00920d60&scoped=true"
import script from "./ModalShowLink.vue?vue&type=script&lang=js"
export * from "./ModalShowLink.vue?vue&type=script&lang=js"
import style0 from "./ModalShowLink.vue?vue&type=style&index=0&id=00920d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00920d60",
  null
  
)

export default component.exports